import { Component, Input, OnInit } from '@angular/core';
import { ChecklistListDataModel } from './checklist-list-data.model';
import { ILightWeightObjectCollection, LocalSearchModel } from '@fi-shared/models';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ChecklistListDataService } from './checklist-list-data.service';
import { ChecklistService } from '../checklist.service';
import { IChecklistListStateModel } from '@fi-app/checklist/checklist';
import { AppTextService } from '@fi-shared/app-text';
import { LoadingService } from '@fi-app/shared/fi-loading/loading.service';
import { getCheckListModulesForLocalSearch } from '@fi-app/checklist/checklist-states';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { FiLocalSearchGroupType } from '@fi-shared/fi-local-search2/fi-local-search-group-type';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';

@Component({
    selector: 'fi-checklist-list',
    templateUrl: './checklist-list.component.html',
    standalone: false,
})
export class ChecklistListComponent extends ItemsListContainerBase<ChecklistListDataModel> implements OnInit {
    @Input() checklistListStateModel: IChecklistListStateModel;
    @Input() sideListOptionsTopChecklist: any;
    @Input() tagIds: number[] = [];

    // note: not used ??
    //_w: () => void;
    modulesForLocalSearch = getCheckListModulesForLocalSearch();

    constructor(
        private appTextService: AppTextService,
        private checklistListDataService: ChecklistListDataService,
        private checklistService: ChecklistService,
        private fiLoadingService: LoadingService,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => <any>this.checklistListStateModel.listData$.value);

        if (this.ListData.Statefull) this.ListData.setFromStateFilterType(this.sideListOptionsTopChecklist);

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
    }

    protected LoadItems(): Promise<void> {
        const fetchingAllData = this.ListData.fetchingAllData;
        const parameter = this.getParameterApiModel();
        parameter.FetchParams = {
            FetchItems: true,
            FetchTotalCount: fetchingAllData,
            FetchLightWeightObjects: fetchingAllData,
        };
        return this.checklistService.getCheckListsListData(parameter).then((response) => {
            this.ListData.appendData(response.Items);

            if (fetchingAllData) {
                this.ListData.SetTotalItemsCount(response.TotalCount);

                const lightWeightObjectCollection = response.LightWeightObjectsForLocalSearch;
                if (lightWeightObjectCollection) {
                    this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
                }
            }
        });
    }

    getParameterApiModel() {
        const result: IItemsListParameterBase = {
            SelectedSort: {
                ColumnName: this.ListData.Sort.Column,
                SortDirection: this.ListData.Sort.Reverse,
            },
            Names: [],
            Ids: [],
            TagIds: this.tagIds,
            FilterType: this.ListData.FilterType,
        };

        Object.assign(result, this.ListData.getOffsetParams());

        this.ListData.mergeLocalSearchV2Parameter(result);

        return result;
    }
}
